import { createUserInvite } from "../../api/userInviteService";

export const useCreateUserInvite = (successCallback) => {
  const create = async (data) => {
    try {
      const newRecord = await createUserInvite(data);
      successCallback(newRecord);
      return newRecord;
    } catch (error) {
      console.error("Failed to create user invite:", error);
      throw error;
    }
  };
  return { create };
};